<template>
    <div class="student-page m-practiceRecord">
        <el-tabs v-model="tabs" type="border-card">

            <!-- 练习 -->
            <el-tab-pane :label="$t('c.practice')" name="practice">
                <div class="btn-group">
                    <button :class="{'active': active === 1}" @click="activeChange(1)">{{$t('c.theory')}}</button>
                    <button :class="{'active': active === 2}" @click="activeChange(2)">{{$t('c.image')}}</button>
                    <button :class="{'active': active === 3}" @click="activeChange(3)">{{$t('c.fiscan')}}</button>
                </div>

                <data-tables
                    class="form-table"
                    ref="recordTable"
                    :data="practiceTable"
                    :table-props="tableProps"
                    :current-page.sync="practiceCurrentPage"
                    :page-size="20"
                    :pagination-props="{pageSizes: [20, 50, 100, 300, 500]}"
                >
                    <el-table-column
                        type="index"
                        align="center"
                        :index="1"
                    />
                    <!-- 列名 -->
                    <el-table-column
                        v-for="title in titles[active]"
                        :key="title.label"
                        :prop="title.prop"
                        :label="title.label"
                        :sortable="true"
                        align="center"
                    />
                    <!-- 操作 -->
                    <el-table-column :label="$t('c.operation')" align="center">
                        <div class="btn-cell" slot-scope="scope">
                            <el-button
                                round
                                size="mini"
                                type="success"
                                :title="$t('c.view')"
                                class="nucfont inuc-preview"
                                @click="checkImgPracticeRecord(scope.row)"
                            />
                        </div>
                    </el-table-column>
                </data-tables>
            </el-tab-pane>

            <!-- 模拟考试 -->
            <el-tab-pane :label="$t('paper.mock')" name="simulated">
                <header class="title">
                    <div class="btn-group">
                        <button :class="{'active': active === 1}" @click="activeChange(1)">
                            {{ $t('c.theory') }}
                        </button>
                        <button :class="{'active': active === 2}" @click="activeChange(2)">
                            {{ $t('c.image') }}
                        </button>
                        <button :class="{'active': active === 3}" @click="activeChange(3)">{{$t('c.fiscan')}}</button>
                    </div>
                    <div>
                        <el-input
                            :placeholder="$t('tip.trainName')"
                            v-model="searchName"
                            style="width: 260px"
                            size="small" clearable
                        >
                            <el-button slot="append" icon="el-icon-search" circle @click="query()" />
                        </el-input>
                    </div>
                </header>

                <data-tables
                    class="form-table"
                    ref="mockTable"
                    :data="mockTable"
                    :table-props="tableProps"
                    :current-page.sync="mockCurrentPage"
                    :page-size="20"
                    :pagination-props="{pageSizes: [20, 50, 100, 300, 500]}"
                >
                    <el-table-column type="index" align="center" :index="1"></el-table-column>
                    <el-table-column prop="planName" :label="$t('train.name')" align="center"
                                     :sortable="true"></el-table-column>
                    <el-table-column prop="paperName" :label="$t('paper.name')" align="center"
                                     :sortable="true"></el-table-column>
                    <el-table-column prop="paperTypeName" :label="$t('paper.type')" align="center"
                                     :sortable="true"></el-table-column>
                    <el-table-column prop="accuracy" :label="$t('topic.rightRate')" align="center"
                                     :sortable="true"></el-table-column>
                    <el-table-column prop="keyAccuracy" :label="$t('paper.keyQuestion')" align="center"
                                     :sortable="true"></el-table-column>
                    <el-table-column prop="score" :label="$t('count.score')" align="center" :sortable="true"></el-table-column>
                    <el-table-column prop="isPass" :label="$t('stu.resultpf')" align="center" :filters="filters"
                                     :filter-method="filterHandler">
                        <template slot-scope="scope">
                            {{scope.row.isPass ? $t('stu.passed') : $t('stu.failed')}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="submitTime" :label="$t('stu.submitDate')" align="center" :sortable="true"
                                     width="120px"></el-table-column>

                    <!-- 操作按钮 -->
                    <el-table-column :label="$t('c.operation')" align="center">
                        <div class="btn-cell" slot-scope="scope">
                            <el-button
                                :title="$t('c.view')"
                                size="mini"
                                type="success"
                                round
                                class="nucfont inuc-preview"
                                @click="checkImgExamRecord(scope.row, true)"
                            />
                        </div>
                    </el-table-column>
                </data-tables>
            </el-tab-pane>

            <!-- 考试 -->
            <el-tab-pane :label="$t('c.exam')" name="exam">
                <header class="title">
                    <div class="btn-group">
                        <button :class="{'active': active === 1}" @click="activeChange(1)">
                            {{ $t('c.theory') }}
                        </button>
                        <button :class="{'active': active === 2}" @click="activeChange(2)">
                            {{ $t('c.image') }}
                        </button>
                        <button :class="{'active': active === 3}" @click="activeChange(3)">{{$t('c.fiscan')}}</button>
                    </div>
                    <div>
                        <el-input
                            style="width: 260px"
                            size="small"
                            clearable
                            :placeholder="$t('tip.trainName')"
                            v-model="searchName"
                        >
                            <el-button slot="append" icon="el-icon-search" circle @click="query()" />
                        </el-input>
                    </div>
                </header>

                <data-tables
                    class="form-table"
                    ref="examTable"
                    :data="examTable"
                    :table-props="tableProps"
                    :current-page.sync="examCurrentPage"
                    :page-size="20"
                    :pagination-props="{pageSizes: [20, 50, 100, 300, 500]}"
                >
                    <el-table-column type="index" align="center" :index="1"></el-table-column>
                    <el-table-column prop="planName" :label="$t('train.name')" align="center"
                                     :sortable="true"></el-table-column>
                    <el-table-column prop="paperName" :label="$t('paper.name')" align="center"
                                     :sortable="true"></el-table-column>
                    <el-table-column prop="paperTypeName" :label="$t('paper.type')" align="center"
                                     :sortable="true"></el-table-column>
                    <el-table-column prop="accuracy" :label="$t('topic.rightRate')" align="center"
                                     :sortable="true"></el-table-column>
                    <el-table-column prop="keyAccuracy" :label="$t('paper.keyQuestion')" align="center"
                                     :sortable="true"></el-table-column>
                    <el-table-column prop="score" :label="$t('count.score')" align="center" :sortable="true"></el-table-column>
                    <el-table-column prop="isPass" :label="$t('stu.resultpf')" align="center" :filters="filters"
                                     :filter-method="filterHandler">
                        <template slot-scope="scope">
                            {{ scope.row.isPass ? $t('stu.passed') : $t('stu.failed') }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="submitTime"
                        width="120px"
                        align="center"
                        :sortable="true"
                        :label="$t('stu.submitDate')"
                    />

                    <!-- 操作按钮 -->
                    <el-table-column :label="$t('c.operation')" align="center">
                        <div class="btn-cell" slot-scope="scope">
                            <el-button
                                :title="$t('c.view')"
                                size="mini"
                                type="success"
                                round
                                class="nucfont inuc-preview"
                                @click="checkImgExamRecord(scope.row, false)"
                            />
                        </div>
                    </el-table-column>
                </data-tables>
            </el-tab-pane>
        </el-tabs>

        <!-- 理论全屏 -->
        <paper-view
            v-if="paperShow"
            :paperInfo="paperInfo"
            :topicData="topicData"
            @close="onPaperClose"
        />

        <fiscan-paper
            ref="fiscanPaper"
            v-model="fiscanPaper.show"
            :data="fiscanPaper.data"
            :type="fiscanPaper.type"
            :usage="2"
        />

        <!-- 图像全屏 -->
        <full-screen
            ref="nstswrap"
            :src="src"
            :isShow="isShow"
            :showCloseBtn="false"
            @changeIsShow="toggleIsShow"
        />
    </div>
</template>

<script>
import api from '@/api';
import { screenfull } from '@/utils';
import paperView from '@/components/Paper/PaperView';
import FiscanPaper from '@components/FiscanPaper';
import FullScreen from '@/components/FullScreen';

export default {
    name: 'MyHistory',
    components: {
        paperView,
        FullScreen,
        FiscanPaper
    },
    data() {
        return {
            isShow: false,
            src: '',
            tabs: 'practice',
            active: 1,
            tableProps: {
                border: false,
                stripe: true,
                height: "auto"
            },

            practiceTable: [],
            practiceCurrentPage: 1,
            titles: {
                1: [
                    {
                        prop: 'total',
                        label: this.$t('stu.topicNum')
                    }, {
                        prop: 'correct',
                        label: this.$t('count.rightNum')
                    }, {
                        prop: 'wrong',
                        label: this.$t('count.wrongNum')
                    }, {
                        prop: 'accuracy',
                        label: this.$t('topic.rightRate')
                    }, {
                        prop: 'submitTime',
                        label: this.$t('stu.submitDate')
                    }
                ],
                2: [
                    {
                        prop: 'typeName',
                        label: this.$t('res.imgType')
                    }, {
                        prop: 'formName',
                        label: this.$t('stu.practiceMode')
                    }, {
                        prop: 'total',
                        label: this.$t('stu.images')
                    }, {
                        prop: 'correct',
                        label: this.$t('count.rightNum')
                    }, {
                        prop: 'wrong',
                        label: this.$t('count.wrongNum')
                    }, {
                        prop: 'overTime',
                        label: this.$t('stu.timeoutNum')
                    }, {
                        prop: 'accuracy',
                        label: this.$t('topic.rightRate')
                    }, {
                        prop: 'submitTime',
                        label: this.$t('stu.submitDate')
                    }
                ],
                3: [
                    {
                        prop: 'formName',
                        label: this.$t('stu.practiceMode')
                    }, {
                        prop: 'total',
                        label: this.$t('stu.images')
                    }, {
                        prop: 'correct',
                        label: this.$t('count.rightNum')
                    }, {
                        prop: 'wrong',
                        label: this.$t('count.wrongNum')
                    }, {
                        prop: 'accuracy',
                        label: this.$t('topic.rightRate')
                    }, {
                        prop: 'submitTime',
                        label: this.$t('stu.submitDate')
                    }
                ],
            },

            mockTable: [],
            mockCurrentPage: 1,
            examTable: [],
            examCurrentPage: 1,

            filters: [
                {
                    text: this.$t('stu.passed'),
                    value: true
                },
                {
                    text: this.$t('stu.failed'),
                    value: false
                }
            ],

            searchName: '',
            paperShow: false,
            paperInfo: {},
            topicData: [],
            // 职鉴
            fiscanPaper: {
                show: false,
                data: null,
                type: ''
            }
        }
    },
    watch: {
        tabs(val) {
            if (!this.hasInitActiveState) {
                this.active = 1
            }
            this.searchName = ''
            this.query()
            this.hasInitActiveState = false
        },
    },
    computed: {
        paperTypes() {
            return {
                1: [1],
                2: [3, 4],
                3: [5],
            }[this.active]
        }
    },
    mounted() {
        // 图像练习跳转
        let { tab, active } = this.$route.query
        if (active) {
            this.active = Number(active)
            this.hasInitActiveState = true
        }
        if (tab && tab !== 'practice') {
            this.tabs = tab
        } else {
            this.query()
        }
    },
    methods: {
        query() {
            if (this.tabs === 'practice') {
                this.practiceCurrentPage = 1;

                if (this.active === 1) {
                    api.queryTheoryStudy().then(res => {
                        this.practiceTable = res.package;
                        this.practiceTable.forEach(item => {
                            item.accuracy = (item.correct / item.total * 100).toFixed(2) + '%';
                            item.submitTime = item.submitTime.slice(0, -3)
                        });
                    });
                } else if (this.active === 2) {
                    api.queryImageStudy().then(res => {
                        this.practiceTable = res.package.map(item => {
                            item.accuracy = (item.correct / item.total * 100).toFixed(2) + '%';
                            item.submitTime = item.submitTime.slice(0, -3);
                            return item
                        })
                    });
                } else if (this.active === 3) {
                    // 职鉴
                    api.queryFiscanStudy().then(res => {
                        this.practiceTable = res.package;
                        this.practiceTable.forEach(item => {
                            item.accuracy = (item.correct / item.total * 100).toFixed(2) + '%';
                            item.submitTime = item.submitTime.slice(0, -3)
                        });
                    });
                }
            }

            if (this.tabs === 'simulated') {
                this.mockCurrentPage = 1;
                let fetchData = {
                    paperTypes: this.paperTypes,
                    trainingName: this.searchName,
                }
                api.queryMockExams(fetchData).then(res => {
                    this.mockTable = res.package;
                    this.mockTable.forEach(item => {
                        item.accuracy = (item.correct / item.total * 100).toFixed(2) + '%';
                        item.keyAccuracy = item.keyAccuracy !==null && (item.keyAccuracy * 100).toFixed(2) + '%' || '--';
                        item.submitTime = item.submitTime.slice(0, -3)
                    });
                });
            }

            if (this.tabs === 'exam') {
                this.examCurrentPage = 1;
                let fetchData = {
                    paperTypes: this.paperTypes,
                    trainingName: this.searchName,
                }
                api.queryExams(fetchData).then(res => {
                    this.examTable = res.package;
                    this.examTable.forEach(item => {
                        item.accuracy = (item.correct / item.total * 100).toFixed(2) + '%';
                        item.keyAccuracy = item.keyAccuracy !==null && (item.keyAccuracy * 100).toFixed(2) + '%' || '--';
                        item.submitTime = item.submitTime.slice(0, -3)
                    });
                });
            }
        },
        // 查看图像练习历史记录
        checkImgPracticeRecord(data) {
            if (this.active === 1) {
                this.paperShow = true;
                screenfull.request();

                api.theoryStudyDetail(data.id).then(res => {
                    this.paperInfo = res.package;

                    let topicData = [];

                    res.package.topics.forEach(item => {
                        topicData.push({
                            topic: item,
                            topicID: item.id,
                            key: false,
                            score: 0
                        })
                    });

                    this.topicData = topicData;
                }).catch(error => {
                    this.paperShow = false;
                    screenfull.exit();
                });
            } else if (this.active === 2) {
                let {id, form, type} = data;
                this.isShow = !this.isShow;

                if (type === 4) {
                    this.src = `${api.imagePanoramicHost}/drPracticeRecord?recordId=${id}&level=${form}&lang=${this.$i18n.locale}`
                    // this.src = `/static/3D/DR_base.html?type=IMAGE_PRACTISE_DETAIL&practiseID=${id}&practiseForm=${form}`
                } else {
                    this.src = `${api.imagePanoramicHost}/ctPracticeRecord?recordId=${id}&level=${form}&lang=${this.$i18n.locale}`
                    // this.src = `/static/3D/CT_base.html?type=IMAGE_PRACTISE_DETAIL&practiseID=${id}&practiseForm=${form}`
                }
                this.$refs.nstswrap.fullScreen()

            } else if (this.active === 3) {
                // 职鉴
                this.fiscanPaper.show = true

                api.fiscanPracticeDetail(data.detailID).then(res => {
                    this.fiscanPaper.data = {
                        ...res.package,
                        form: data.form
                    }
                    this.fiscanPaper.type = 'practice'
                }).catch(() => {this.fiscanPaper.show = false})
            }
        },
        // 查看图像模拟考试、考试历史记录
        checkImgExamRecord(data, isMock) {
            let {paperType, itemId, testID} = data;

            // 理论
            if (paperType === 1) {
                screenfull.request();
                this.paperShow = true;

                let request;
                if (isMock) {
                    request = api.mockExamHistory(itemId)
                } else {
                    request = api.examDetail(testID)
                }
                request.then(res => {
                    let data = res.package;

                    this.topicData = data.paper.relationship;

                    this.paperInfo = {
                        response: data.records,
                        isSubmit: data.isSubmit,
                        score: data.score,
                        totalSeconds: data.totalSeconds,
                        ...data.paper,
                    };
                }).catch(error => {
                    this.paperShow = false;
                    screenfull.exit();
                });

                // CT DR
            } else if (paperType === 3 || paperType === 4) {
                this.isShow = !this.isShow;
                if (isMock) {
                    if (paperType === 4) {
                        this.src = `${api.imagePanoramicHost}/drExamMockRecord?recordId=${itemId}&lang=${this.$i18n.locale}`
                        // this.src = `/static/3D/DR_base.html?type=IMAGE_MOCK_EXAM_HISTORY&examID=${itemId}&examStatus=2`
                    } else {
                        this.src = `${api.imagePanoramicHost}/ctExamMockRecord?recordId=${itemId}&lang=${this.$i18n.locale}`
                        // this.src = `/static/3D/CT_base.html?type=IMAGE_MOCK_EXAM_HISTORY&examID=${itemId}&examStatus=2`
                    }
                } else {
                    if (paperType === 4) {
                        this.src = `${api.imagePanoramicHost}/drExamRecord?recordId=${testID}&lang=${this.$i18n.locale}`
                        // this.src = `/static/3D/DR_base.html?type=IMAGE_EXAM&examID=${testID}&examStatus=2`
                    } else {
                        this.src = `${api.imagePanoramicHost}/ctExamRecord?recordId=${testID}&lang=${this.$i18n.locale}`
                        // this.src = `/static/3D/CT_base.html?type=IMAGE_EXAM&examID=${testID}&examStatus=2`
                    }
                }
                this.$refs.nstswrap.fullScreen()

            } else if (paperType === 5) {
                // 职鉴
                this.fiscanPaper.show = true

                let request
                if (isMock) {
                    request = api.mockExamHistory(itemId)
                } else {
                    request = api.examDetail(testID)
                }

                request.then(res => {
                    this.fiscanPaper.data = res.package
                    this.fiscanPaper.type = 'exam'
                }).catch(() => {this.fiscanPaper.show = false})
            }
        },
        filterHandler(value, row) {
            return value === row.isPass;
        },
        activeChange(data) {
            if (this.active === data) return;
            this.active = data;
            this.query();
        },
        onPaperClose() {
            this.paperShow = false
            this.paperInfo = {}
            this.topicData = []
        },
        onFiscanPaperClose() {
            this.fiscanPaperShow = false;
        },
        toggleIsShow(val) {
            this.isShow = val;
            this.src = null;
        }
    }
}
</script>

<style scoped lang="scss">
@import '../../style/const.scss';

.student-page {
    padding-top: 40px;
    padding-bottom: 40px;
}

.btn-group {
    margin-bottom: 25px;

    button {
        margin-right: 10px;
        padding: 8px 28px;
        outline: 0;
        color: #2f3238;
        background-color: #f5f6f7;
        border: 1px solid #f5f6f7;
        border-radius: 2px;
        cursor: pointer;

        &.active {
            background-color: $color-theme;
            color: #fff;
        }
    }
}

.form-table {
    display: flex;
    flex: 1;
    flex-direction: column;
    min-height: 0;
}
</style>

<style lang="scss">
.student-page {

    .form-table {
        thead th {
            font-size: 16px;
            background-color: #f4f3f8;
        }
        &.sc-table td {
            padding: 10px 0;
        }
    }

}

.m-practiceRecord {
    height: 100%;

    > .el-tabs {
        display: flex;
        flex-direction: column;
        height: 100%;
        .el-tabs__content {
            flex: 1;
        }
        .el-tab-pane {
            display: flex;
            flex-direction: column;
            height: 100%;
        }
    }

    .title {
        display: flex;
        justify-content: space-between;
    }
}
</style>
